import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import store from './store';
import { get, post } from '@/utils/request';
import utils from '@/utils/utils';
import VueCompositionAPI from '@vue/composition-api';
import WebSocketPlugin from './plugins/websocket';
Vue.use(VueCompositionAPI);
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$utils = utils;
Vue.config.productionTip = false;

// 引入 axios 并挂载到原型
import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.use(ElementUI);

new Vue({
    store,
    router,
    WebSocketPlugin,
    render: (h) => h(App),
}).$mount('#app');
